import { Component, OnInit, OnDestroy, ViewChild, ElementRef}  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IQueryReportResponse, IQueryReportRequest, IQueryReportListComponent, IQueryReportsFacilityRequest } from './query-report'
import { QueryReportService } from './query-report.service';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';
import { UserInfoService } from '../shared/user-info.service';
import {SystemControl} from '../shared/system-control';
import {SystemControlElem} from '../shared/system-control-elem';
import { SystemControlService} from '../shared/system-control.service';


import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';
import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';
import {Paginator} from 'primeng/primeng';


@Component({
    template: require('./query-report.component.html'),
    styles: [require('../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES,Dialog]
})

export class QueryReportComponent implements OnInit, OnDestroy{
    pageTitle: string = 'Query Reports';
    errorMessage: string;
    private sub: any;
    msgs: Messages[]=[];
    cols: any[];
    systemControlElem: SystemControlElem;

    facReportListResponse : IQueryReportResponse[];
    request : IQueryReportRequest ;
    currentScenario: IScenario;
    allScenarios: IScenario[];
    scenarioHeaderDiv: HTMLDivElement;
    isScenarioOwner: boolean = false;
    

    options:Array<IQueryReportListComponent>;
    facOptions:Array<IQueryReportListComponent>;
    selectedOption: IQueryReportListComponent;
    selectedFacOption: IQueryReportListComponent;
    hideElement:boolean =false;
    showLocids:boolean=false;
    showGraphs: boolean =false;
    displaySpinner :boolean=false;

    selectedLocids:string;
    requestLocid: IQueryReportsFacilityRequest;
    locidResponse :IQueryReportResponse;
    
    graphOptions : any[];
    locidCnt :number =0;
    graphTableSelected:string;
    graphIdSelected:number=0;
    allYears :Array<IQueryReportListComponent>;
    yearIdSelected :number=0;
    scenarioDDL:HTMLSelectElement;
    selYear :number;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _queryReportService: QueryReportService,               
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService,
                private _systemControlService:SystemControlService) {

                    this.selectedOption= new IQueryReportListComponent(1, 'Scenario Quick Data Summary Report ');
                    this.selectedFacOption= new IQueryReportListComponent(9, 'Select all LOCIDs  ');
                    this.options = [
                            new IQueryReportListComponent(1, 'Scenario Quick Data Summary Report '),
                            new IQueryReportListComponent(2, 'Scenario Quick Growth Rate Summary Report '),
                            new IQueryReportListComponent(3, 'Scenario Operations and Enplanement Data Summary  (Date range is always last history year through last forecast year) '),
                            new IQueryReportListComponent(4, 'Scenario Operations and Enplanement Growth Rates Summary  (Date range is always last history year through last forecast year) '),
                            new IQueryReportListComponent(5, 'Scenario Facility List   (Date range does not affect this report) '),
                            new IQueryReportListComponent(6, 'Facility Quick Data Summary Report '),
                            new IQueryReportListComponent(7, 'Facility Quick Growth Rate Summary Report '),
                            new IQueryReportListComponent(8, 'Produce Graphs (for the entire scenario)  ')

                        ];
                    this.facOptions=[
                        new IQueryReportListComponent(9, 'Select all LOCIDs  '),
                        new IQueryReportListComponent(10, 'Select a subset of LOCIDs '),
                    ];
                    this.graphOptions=[
                        {display: 'Airport Operations', value: 0, dbName:'AirportOperations'},
                        {display: 'Based Aircraft', value: 1,dbName:'Basedaircraft'},
                        {display: 'Enplanements', value: 2, dbName:'Enplanements'},
                        {display: 'Tracon Operations', value: 3,dbName:'TraconOPS'}
                    ];
                    this.allYears = [new IQueryReportListComponent(0,'')];
     }

    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;
    
    ngOnInit(): void{
       
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );
      
        //this probably needs to be somewhere more central
        this.User.updateSessionState();
        
        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );
        this.getSystemControlValues();
        //this.locidResponse = new IQueryReportResponse('','','','','',[],[]);
    }
    
    getSystemControlValues(){
        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => {
                        this.systemControlElem = systemControlElem;
                },
                error => this.errorMessage = <any>error,
                ()=>{
                        this.selYear = this.systemControlElem.fyYear -3;
                        this.request = new IQueryReportRequest(this.systemControlElem.fyYear -3,1,1,9,[]);
                        this.requestLocid=new IQueryReportsFacilityRequest([''],1);

                        //set first year of report dropdown; rather than going to the database for this dropdown, we will create the data array here
                        // using sysControl Fyear-3 as end point and 1980 as first year of report.
                        
                        for(let year = 1976; year <=this.systemControlElem.fyYear-3; year++){
                               this.allYears.push( new IQueryReportListComponent(year, year+""));
                        }
                        this.yearIdSelected = this.systemControlElem.fyYear-3;
                });
    }
    getValueFacOpt(optionid:number){
        this.selectedFacOption = this.facOptions.filter((item)=> item.id == optionid)[0];
        if(this.selectedFacOption.id==10){
            this.showLocids=true;
        }
        else{
            this.showLocids =false;
        }
    }
    onYearChange(event: Event): void {
         let yearOptionSelected: number = +(event.target as HTMLSelectElement).value;
         this.yearIdSelected = yearOptionSelected;
    }

    onGraphSelectionChange(event: Event): void {
         let graphOptionSelected: number = +(event.target as HTMLSelectElement).value;
         this.graphIdSelected = graphOptionSelected;
    }

    onScenarioChange(event: Event): void {
        let selectedScenarioId: number = +(event.target as HTMLSelectElement).value;
        this.User.scenarioId = selectedScenarioId;
        this.setScenarioHeader(selectedScenarioId);
        this.User.updateSessionState();
    }
    getValue(optionid:number) {
      this.selectedOption = this.options.filter((item)=> item.id == optionid)[0];
     
      if(this.selectedOption.id ===7 || this.selectedOption.id ===6 ){
          this.hideElement = true;
      }
      else
      {
          this.hideElement = false;
      }
      if(this.selectedOption.id ===8){
          this.showGraphs = true;
      }
      else{
          this.showGraphs =false;
      }
    }
    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }

    generateReport(){
         
          this.msgs=[];
          this.displaySpinner = true;
          this.request.scenario = this.currentScenario.id;
          this.request.startYear = this.yearIdSelected;
          this.request.reportId = this.selectedOption.id;
          this.request.facOption = this.selectedFacOption.id;
          this.request.locidList=[];
         
          if(this.request.startYear==0){
                this.msgs=[];
                this.msgs.push({severity:'info', summary:'Info Message', detail: 'Please select start year.' });
                this.displaySpinner = false;
                return;
          }
          if(this.locidResponse == null 
             && this.selectedFacOption.id === 10
             && (this.request.reportId ===6 || this.request.reportId === 7))
          {
            this.msgs=[];
            this.msgs.push({severity:'info', summary:'Info Message', detail: 'Please select at least one locid for Facility level reports.' });
            this.displaySpinner = false;
            return;
          }
          else if( this.locidResponse != null &&
                this.selectedFacOption.id === 10){
             this.request.locidList = this.locidResponse.savedLocidList;
          }
          if(this.request.reportId === 8){
               let params = {
                    startYear:this.yearIdSelected,
                    endYear:this.systemControlElem.lfcYear,
                    scenario:this.request.scenario,
                    tableId:this.graphIdSelected,
                    reportId: this.request.reportId
                }
               this.router.navigate([`/query-reports-graph-selections`, params]);
               return;
          }
          this._queryReportService.getFacilityListReport(this.request)
                .subscribe(
                response => {
                    this.displaySpinner = false;
                    this.facReportListResponse = response;
                    if (this.facReportListResponse[0].responseStatus === 'ERROR') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error has occurred executing your request'
                                        +this.facReportListResponse[0].responseMessage});
                    }
                    else if (this.facReportListResponse[0].responseMessage === 'No Data') {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Info Message', detail: 'No Data returned.'
                                        +this.facReportListResponse[0].responseMessage});
                        this.facReportListResponse[0].pdfFileUrl="";
                        this.facReportListResponse[0].htmlFileUrl="";
                    }
                    else{
                        this.msgs=[];
                        this.msgs.push({severity:'info', summary:'Info Message', detail: 'PDF & HTML file generated; please click links below' });
                        this.cols = [
                                    {field: "htmlFileUrl", header: 'Html'},
                                    {field: "pdfFileUrl", header: 'Pdf'},
                        ]
                        if(this.request.reportId ===6 || this.request.reportId === 7){
                         this.locidResponse.savedLocidList=null;
                         this.locidCnt =0;
                        }
                    }
                    //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
                    //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
                    //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
                },
                error => this.errorMessage = <any>error
                );
    }
   /* removeFacilityFromList(locid: string): void {
        let index: number = this.request.facilities.indexOf(locid);
        this.request.facilities.splice(index, 1);
    }

    clearAllFacilities(): void {
        this.request.facilities = [];
    }*/
    cancelLocids(){
        this.showLocids = false;
        this.selectedLocids='';
        
    }
    removeFacilityFromList(locid: string): void {
        let index: number = this.locidResponse.savedLocidList.indexOf(locid);
        this.locidResponse.savedLocidList.splice(index, 1);
        this.locidCnt =this.locidResponse.savedLocidList.length;
    }
    cancel(){
        this.router.navigate(['/welcome']);
    }
    saveLocids() { 

        var charExp = /[^a-zA-Z0-9]+/;
        let nonAlpha = ( this.selectedLocids.replace (/[\t\n\s\r]{1,}/g,"")).match(charExp);
        if(nonAlpha != null){
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please check the list of LOCID.\nIt can only contain digits[0-9] and alphabets[a-z].' });
            return;
        }
        let selectedLocidsArr  = this.selectedLocids.replace (/[\t\n\s\r]{1,}/g,",").split(",");
        let bError = false;
        for(var i=0; i<=selectedLocidsArr.length-1; i++){
            if((selectedLocidsArr[i])!=null){
                if((selectedLocidsArr[i].length>4) || (selectedLocidsArr[i].length <3)){
                        bError=true;
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'The LOCID length can be only 3 or 4 characters.' });
                        return;
                }
            }
        }
        this.requestLocid.locid=selectedLocidsArr;
        this.requestLocid.scenarioId = this.currentScenario.id;
        this._queryReportService.saveLocids(this.requestLocid)
                .subscribe(
                    response => {
                        this.locidResponse = response;
                        
                        if(this.locidResponse.responseMessage ==="No Match"){
                            this.msgs=[];
                            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Following Locid list is not part of your selected scenario '
                                            + this.locidResponse.locidNoMatch + '. Please correct the errors before continuing.'});
                             this.locidCnt = 0;
                        }
                        this.showLocids = false;
                        if(this.locidResponse.savedLocidList != null)
                        {
                            this.locidCnt = this.locidResponse.savedLocidList.length;
                            //console.log("locidResponse.savedLocidList: "+this.locidResponse.savedLocidList.length);
                           // console.log("locidResponse.responseStatus: "+this.locidResponse.responseStatus);
                        }
                    },
                    error => {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while processing your request.' });
                        this.showLocids = false;
                        this.locidCnt = 0;
                    },
                    () => {}
                );
    this.selectedLocids='';
    }
    openPDFFile(responsepdf:any){
        window.open(responsepdf, '_blank');
    }
    openHTMLFile(responseHtml:any){
        window.open(responseHtml, '_blank');
    }
    ngOnDestroy() {
       // this.sub.unsubscribe();
   }
}



/** WEBPACK FOOTER **
 ** ./app/query-reports/query-report.component.ts
 **/